import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { MessageService } from 'primeng/api';


@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    public toastController: ToastController,
    private messageService: MessageService
  ) { }

  success(detail: string) {
    this.messageService.add({ severity: 'success',summary: 'Success', detail, life: 2000  });
  }

  error(detail: string) {
    this.messageService.add({ severity: 'error',summary: 'Failed', detail, life: 2000 });
  }

  async presentToast(msg:any, cls:any, icon:any) {
    const toast = await this.toastController.create({
      message: msg,
      color: cls,
      icon: icon,
      duration: 5000,
      position: 'top',
      cssClass: 'toastAfterHeader'
    });
    toast.present();
  }

 

}
